<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='1400px' center top='10vh'
             @close='dialogClose' :close-on-click-modal='false'>
    <el-table
      :data='tableData'
      v-loading='tableLoading'
      style='width: 98%; margin: 10px auto;'
      border
      :header-cell-style='headerCellStyle'
    >
      <el-table-column prop='standingBookMonth' label='台账月' align='center' min-width='100px' />
      <el-table-column prop='consignorName' label='委托商' align='center' min-width='180px' />
      <el-table-column prop='departurePlace' label='起始地' align='center' min-width='180px' />
      <el-table-column prop='departurePort' label='起始港' align='center' min-width='180px' />
      <el-table-column prop='arrivePort' label='交车港' align='center' min-width='180px' />
      <el-table-column prop='arrivePlace' label='交车地' align='center' min-width='180px' />
      <el-table-column label='运输方式' align='center' min-width='100px'>
        <template slot-scope='scope'>
          {{ scope.row.transType === 1 ? '公路' : scope.row.transType === 2 ? '水路' : '水陆联运' }}
        </template>
      </el-table-column>
      <el-table-column v-if='isAccount === 1' prop='taxRate' label='运费税率' align='center'
                       min-width='100px' />
      <el-table-column :prop='isAccount === 1 ? "taxContractPrice" : "taxPriceDiffer"'
                       :label='isAccount === 1 ? "含税运费总金额" : "含税总差额"'
                       align='center' min-width='100px' />
      <el-table-column v-if='isAccount === 1' label='装卸费税率' align='center' min-width='100px'>
        <template slot-scope='scope'>{{ scope.row.zxRate || 0 }}</template>
      </el-table-column>
      <el-table-column v-if='isAccount === 1' prop='taxZxPrice' label='含税装卸费总金额' align='center'
                       min-width='120px' />
      <el-table-column prop='supplierName' label='供应商' align='center' min-width='180px' />
      <el-table-column prop='typeName' label='费用类型' align='center' min-width='100px'>
        <template slot-scope='scope'>
          {{ getType(scope.row.type2) }}
        </template>
      </el-table-column>
      <el-table-column v-if='isAccount === 1' prop='taxRate2' label='税率' align='center'
                       min-width='100px' />
      <el-table-column :prop='isAccount === 1 ? "taxContractPrice2" : "taxPriceDiffer2"'
                       :label='isAccount === 1 ? "含税总金额" : "含税总差额"'
                       align='center' min-width='100px' />
      <!--      <el-table-column prop='status' label='其他费用' align='center' min-width='150px'>
              <template slot-scope='scope'>
                <el-select v-model='tableData[scope.$index].qtfy' filterable size='mini'
                           style='width:100%' placeholder='请选择其他费用' multiple collapse-tags>
                  <el-option v-for='item in qtfyOption' :key='item.label' :label='item.label'
                             :value='item.value' />
                </el-select>
              </template>
            </el-table-column>-->
    </el-table>
    <div class='btnContainer'>
      <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submitClick'>提交
      </el-button>
      <el-button size='medium' class='resetBtn' @click='dialogClose'>取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { generateAccount, getAccountDetail } from '@/service/account';
  import { portWarehouseLedgerGenerate } from '@/service/warehouse';

  export default {
    name: 'accountAndReconciliation',
    data() {
      return {
        dialogTitle: '',
        tableLoading: false,
        dialogVisible: false,
        submitLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        qtfyOption: [{
          label: '其它费用一',
          value: '其它费用一',
        }, {
          label: '其它费用二',
          value: '其它费用二',
        }, {
          label: '其它费用三',
          value: '其它费用三',
        }],
        isAccount: '',
        isAdjust: '',
        ids: [],
      };
    },
    methods: {
      getType(type) {
        switch (type) {
          case 1:
            return '公路运费';
          case 2:
            return '水路运费';
          case 3:
            return '装船费';
          case 4:
            return '卸船费';
          case 5:
            return '过驳费';
          case 6:
            return '转船费';
          case 7:
            return '堆存费';
          case 8:
            return '提车费';
          default:
            return '--';
        }
      },
      async submitClick() {
        this.submitLoading = true;
        const {
          status,
          message,
        } = await portWarehouseLedgerGenerate({
          childIds: this.ids,
          isAccount: this.isAccount,
          isAdjust: this.isAdjust,
        });
        this.submitLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.$emit('getTableData');
        this.dialogClose();
      },
      // 打开弹出框
      dialogOpen(obj) {
        if (obj.name === '生成台账') {
          this.isAccount = 1;
          this.isAdjust = 0;
        } else {
          this.isAccount = 0;
          this.isAdjust = 1;
        }
        this.dialogTitle = obj.name;
        this.ids = obj.ids;
        this.getTableData(obj.ids);
        this.dialogVisible = true;
      },
      async getTableData(ids) {
        this.tableLoading = true;
        const data = await getAccountDetail({ childIds: ids });
        this.tableLoading = false;
        this.tableData = data.data;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang='scss' scoped>
  ::v-deep .el-dialog {
    //max-height: 78vh;
    overflow: auto;
  }

  .btnContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 13px;
    margin-top: 20px;

    button {
      margin: 0 15px;
    }
  }
</style>
